import { Task } from '@graphql/generated';

export const getTaskMembersSignature = (task: Task) =>
  (task.members || [])
    .map((member) => `${member.role}:${member.user.id}`)
    .sort((a, b) => a.localeCompare(b))
    .join('|');

export const areTasksVisuallyEqual = (prevTask: Task, nextTask: Task) =>
  prevTask.id === nextTask.id &&
  prevTask.name === nextTask.name &&
  prevTask.completedAt === nextTask.completedAt &&
  prevTask.status === nextTask.status &&
  prevTask.priority === nextTask.priority &&
  prevTask.startDate === nextTask.startDate &&
  prevTask.dueDate === nextTask.dueDate &&
  prevTask.project?.id === nextTask.project?.id &&
  prevTask.project?.name === nextTask.project?.name &&
  prevTask.project?.icon === nextTask.project?.icon &&
  prevTask.project?.color === nextTask.project?.color &&
  prevTask.currentUserRole === nextTask.currentUserRole &&
  prevTask.currentUserProjectRole === nextTask.currentUserProjectRole &&
  prevTask.currentUserProjectTeamRole === nextTask.currentUserProjectTeamRole &&
  getTaskMembersSignature(prevTask) === getTaskMembersSignature(nextTask);
